import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import { NeedHelpIcon } from "./Icons";
import agencyIQLogo from "./../../assets/agencyIQ_Logo.png";
import { Link } from "@material-ui/core";
import { AgencySetupUserInfo } from "./AgencySetupUserInfo";

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    flexGrow: 1,
  },
  appBar: {
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.down("md")]: {
      height: 147,
    },
    [theme.breakpoints.up("md")]: {
      height: 80,
    },
    boxShadow: "0px 0px 10px rgba(45, 96, 137, 0.5)",
  },
  gridContent: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  needHelp: {
    fontWeight: 600,
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: 90,
  },
  logoContainer: {
    minHeight: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "100%",
  },
  logo: {
    height: 50,
  },
  logoAlt: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    cursor: "pointer",
  },
}));

const NEED_HELP_NON_SIAA_LINK = `${process.env.REACT_APP_NEED_HELP_NON_SIAA_LINK}`;

export function HeaderForAgent() {
  const classes = useStyles();
  const homePath = "/";

  const gridPoints = {
    md: 6,
    lg: 6,
    xl: 6,
  };
  const needHelpLink = NEED_HELP_NON_SIAA_LINK;
  return (
    <>
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar>
          <div className={classes.gridRoot}>
            <Grid container spacing={2} justify="space-between">
              <Grid
                item
                md={gridPoints.md}
                lg={gridPoints.lg}
                xl={gridPoints.xl}
                spacing={1}
                justify="flex-start"
                align="center"
                container
              >
                <div className={classes.logoContainer}>
                  <div className={classes.logoAlt}>
                    <Link to={homePath}>
                      <img
                        className={classes.logo}
                        src={agencyIQLogo}
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
              </Grid>
              <Grid
                item
                md={gridPoints.md}
                lg={gridPoints.lg}
                xl={gridPoints.xl}
                className={classes.gridContent}
              >
                <a href={needHelpLink} target="_blank">
                  <div className={classes.needHelp}>
                    Need Help <NeedHelpIcon />
                  </div>
                </a>
                <AgencySetupUserInfo />
              </Grid>
            </Grid>
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
}
